module.exports = __webpack_public_path__ + "img/dmng-app.7ae7cd7e.png";